import React, { Fragment } from 'react';
import { H4, H6, P, UL } from '../../../AbstractElements';

const FormHeader = (props) => {
    const { selected = '', t } = props;
    return (
        <Fragment>
            <div>
                <H4>{t("Change your password")}</H4>
            </div>
        </Fragment>
    );
};
export default FormHeader;
